import Swiper from 'swiper'
import { Mousewheel, Navigation, Scrollbar } from 'swiper/modules'

export default function () {
	document.addEventListener('DOMContentLoaded', function () {
		const blogPostsSliderEls = document.querySelectorAll('.section-blog-posts-carousel-slider')
		if (blogPostsSliderEls) {
			blogPostsSliderEls.forEach((blogPostsSliderEl) => {
				const sectionEl = blogPostsSliderEl.closest('.section-blog-posts-carousel')
				if (sectionEl) {
					const id = sectionEl.id
					new Swiper(blogPostsSliderEl as HTMLElement, {
						modules: [Navigation, Mousewheel, Scrollbar],
						slidesPerView: 1,
						centeredSlides: true,
						spaceBetween: 144,
						navigation: {
							prevEl: `#${id} .prev`,
							nextEl: `#${id} .next`,
							disabledClass: 'btn-disabled',
						},
						breakpoints: {
							1191: {
								spaceBetween: 0,
							},
						},
						mousewheel: {
							enabled: true,
							forceToAxis: true,
						},
						scrollbar: {
							el: `#${id} .swiper-scrollbar`,
						},
					})
				}
			})
		}
	})
}
